"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trailing_slash = exports.resolve = exports.Urls = void 0;
var Urls = (function () {
    function Urls() {
    }
    Urls.import_project = "/{0}/import/";
    Urls.risk_list = "/{0}/risks/";
    Urls.risk_list_data = "/{0}/risks/data/";
    Urls.risk_list_settings = "/{0}/risks/settings/";
    Urls.risk_list_filter_state = "/{0}/risks/filter_state/";
    Urls.risk_list_update = "/{0}/risks/update/";
    Urls.risk_create = "/{0}/risks/new";
    Urls.risk_detail = "/{0}/risks/{1}";
    Urls.risk_excel = "/{0}/risks/excel";
    Urls.risk_add_new = "/{0}/risks/new/";
    Urls.control_list = "/{0}/controls/";
    Urls.control_list_data = "/{0}/controls/data/";
    Urls.control_list_update = "/{0}/controls/update/";
    Urls.control_list_settings = "/{0}/controls/settings/";
    Urls.control_list_filter_state = "/{0}/controls/filter_state/";
    Urls.control_detail = "/{0}/controls/?control_id={1}";
    Urls.control_excel = "/{0}/controls/excel";
    Urls.control_check_detach_causality = "/{0}/controls/{1}/check_detach_causality/{2}";
    Urls.control_detach_causality = "/{0}/controls/{1}/causality_relations/detach_causality/{2}";
    Urls.action_list = "/{0}/actions/";
    Urls.action_list_data = "/{0}/actions/data/";
    Urls.action_list_update = "/{0}/actions/update/";
    Urls.action_list_settings = "/{0}/actions/settings/";
    Urls.action_list_filter_state = "/{0}/actions/filter_state/";
    Urls.action_detail = "/{0}/actions/?action_id={1}";
    Urls.action_excel = "/{0}/actions/excel";
    Urls.edit_ownership_list = "/{0}/admin/remap/{1}";
    Urls.edit_ownership_status_choices = "/{0}/status_choices/";
    Urls.set_risk_evaluation = "/{0}/risks/{1}/matrix_eval";
    Urls.risk_matrix_with_evaluations = "/{0}/risktargets/matrix/{1}/risk/{2}/evaluations";
    Urls.risk_evaluated_cell = "/{0}/risks/{1}/get_eval_cell";
    Urls.current_evaluation_equals_default = "/{0}/risktargets/matrix/json/{1}/{2}/{3}";
    Urls.check_detach_causality = "/{0}/risks/{1}/check_detach_causality/{2}";
    Urls.check_detach_risk_from_control = "/{0}/controls/{1}/check_detach_from_risk/{2}";
    Urls.detach_risk_from_control = "/{0}/controls/{1}/detach_from_risk/{2}";
    Urls.detach_risk_from_causality = "/{0}/risks/{1}/detach_from_risk/{2}";
    Urls.update_risk_review = "/{0}/risks/{1}/update_review/";
    Urls.has_review_permission = "/{0}/has_review_permission/";
    Urls.risk_exclusive_controls_list = "/{0}/risks/{1}/exclusive_controls";
    Urls.responsibility_filter_state = "/responsibilities/{0}/filter_state";
    Urls.responsibility_cross_pjt_filter_state = "/responsibilities/filter_state";
    Urls.responsibility_data = "/responsibilities/{0}/data";
    Urls.responsibility_cross_pjt_data = "/responsibilities/data";
    Urls.reference_dialog_filter_state = "/{0}/references/filter_state/{1}/";
    Urls.referencable_risks = "/{0}/risks/referencable/";
    Urls.referencable_controls = "/{0}/controls/referencable/";
    Urls.referencable_actions = "/{0}/actions/referencable/";
    Urls.edit_reference = "/{0}/references/edit/{1}/";
    Urls.delete_reference = "/{0}/references/delete/{1}/";
    Urls.cause_list = "/{0}/risks/causes/";
    Urls.effect_list = "/{0}/risks/effects/";
    Urls.cause_list_update = "/{0}/risks/causes/update/";
    Urls.effect_list_update = "/{0}/risks/effects/update/";
    Urls.cause_list_data = "/{0}/risks/causes/data/";
    Urls.effect_list_data = "/{0}/risks/effects/data/";
    Urls.cause_list_settings = "/{0}/risks/causes/settings/";
    Urls.effect_list_settings = "/{0}/risks/effects/settings/";
    Urls.cause_list_filter_state = "/{0}/risks/causes/filter_state/";
    Urls.effect_list_filter_state = "/{0}/risks/effects/filter_state/";
    Urls.cause_bulk_menu_state = "/{0}/risks/causes/bulk_menu_state/";
    Urls.effect_bulk_menu_state = "/{0}/risks/effects/bulk_menu_state/";
    Urls.cause_excel = "/{0}/risks/causes/excel";
    Urls.effect_excel = "/{0}/risks/effects/excel";
    Urls.causality_control_relations = "/{0}/risks/{1}/control_relations/";
    Urls.overview_options_context = "/overview/options/";
    Urls.overview_status_count = "/overview/status/count/";
    Urls.overview_status_todo = "/overview/status/todo/";
    Urls.overview_bar_plot = "/overview/barplot/";
    Urls.overview_value_at_risk = "/overview/valueatrisk/";
    Urls.overview_ownership = "/overview/ownership/";
    Urls.overview_tag = "/overview/tag/";
    Urls.overview_matrix = "/overview/matrix/";
    Urls.overview_simulation = "/overview/simulation/";
    Urls.admin_base = "/{0}/admin/";
    Urls.admin_project_info = Urls.admin_base + "edit/";
    Urls.remove_project_logo = "/{0}/remove_image/";
    Urls.admin_categories = Urls.admin_base + "categories/json/";
    Urls.admin_ca_categories = Urls.admin_base + "categories/catags/";
    Urls.admin_copy_categories = Urls.admin_base + "categories/tags/copy/";
    Urls.admin_copy_ca_categories = Urls.admin_base + "categories/catags/copy/";
    Urls.admin_risktargets = "/{0}/risktargets/";
    Urls.admin_risktargets_riskcolorchoices = Urls.admin_risktargets + "riskcolorchoices/";
    Urls.admin_risktargets_opportunitycolorchoices = Urls.admin_risktargets + "opportunitycolorchoices/";
    Urls.admin_risktargets_matrixoriginchoices = Urls.admin_risktargets + "matrixoriginchoices/";
    Urls.admin_risktargets_matrixorientationchoices = Urls.admin_risktargets + "matrixorientationchoices/";
    Urls.admin_risktargets_matrixlikelihoodchoices = Urls.admin_risktargets + "matrixlikelihoodchoices/";
    Urls.admin_risktargets_move_up = Urls.admin_risktargets + "{1}/move_up";
    Urls.admin_risktargets_move_down = Urls.admin_risktargets + "{1}/move_down";
    Urls.admin_create_risktarget = Urls.admin_risktargets + "new";
    Urls.admin_edit_matrix = Urls.admin_risktargets + "matrix/{1}/freq_cons";
    Urls.admin_create_matrix = Urls.admin_risktargets + "{1}/creatematrix";
    Urls.admin_remove_risktarget = Urls.admin_risktargets + "{1}/remove";
    Urls.admin_remove_matrix = Urls.admin_risktargets + "matrix/remove/{1}";
    Urls.admin_copy_riskarget = Urls.admin_risktargets + "{1}/copy_risktarget";
    Urls.admin_import_risktargets = Urls.admin_risktargets + "copy/";
    Urls.admin_get_users = "/{0}/all_users/";
    Urls.api_user_list_me = "/identify/";
    Urls.api_user_pair_2fa = "/pair-twofactor/";
    Urls.api_user_enable_2fa = "/enable-twofactor/";
    Urls.api_user_disable_2fa = "/disable-twofactor/";
    Urls.api_project_list = "/api/v1/projects";
    Urls.api_project_detail = "/api/v1/projects/{0}";
    Urls.api_project_user_list = "/api/v1/projects/{0}/users";
    Urls.api_project_risk_list = "/api/v1/projects/{0}/risks";
    Urls.api_project_risk_detail = "/api/v1/projects/{0}/risks/{1}";
    Urls.api_project_risk_review_detail = "/api/v1/projects/{0}/risks/{1}/riskreview";
    Urls.api_project_risk_control_list = "/api/v1/projects/{0}/risks/{1}/controls";
    Urls.api_project_risk_riskcontrol_list = "/api/v1/projects/{0}/risks/{1}/riskcontrols";
    Urls.api_project_risk_attachable_controls_list = "/api/v1/projects/{0}/risks/{1}/attachable_controls";
    Urls.api_project_control_attachable_risks_list = "/api/v2/projects/{0}/controls/{1}/attachable_risks";
    Urls.api_project_risk_references_list = "/api/v1/projects/{0}/risks/{1}/references";
    Urls.api_project_risk_references_detail = "/api/v1/projects/{0}/risks/{1}/references/{2}";
    Urls.api_risk_causality_list = "/api/v1/projects/{0}/risks/{1}/causalities";
    Urls.api_control_causality_list = "/api/v1/projects/{0}/controls/{1}/causalities";
    Urls.api_risk_attachable_causalities_list = "/api/v1/projects/{0}/risks/{1}/attachable_causalities";
    Urls.api_control_attachable_causalities_list = "/api/v1/projects/{0}/controls/{1}/attachable_causalities";
    Urls.api_risk_causality_detail = "/api/v1/projects/{0}/risks/{1}/causalities/{2}";
    Urls.api_project_causality_detail = "/api/v1/projects/{0}/causalities/{1}";
    Urls.api_project_causality_list = "/api/v1/projects/{0}/causalities";
    Urls.api_project_causality_comment_list = "/api/v1/projects/{0}/causalities/{1}/comments";
    Urls.api_project_causalities_comment_detail = "/api/v1/projects/{0}/causalities/{1}/comments/{2}";
    Urls.api_causality_affected_risk_list = "/api/v1/projects/{0}/causalities/{1}/affected_risks";
    Urls.api_causality_attachable_risks_list = "/api/v1/projects/{0}/causalities/{1}/attachable_risks";
    Urls.api_causality_affected_control_list = "/api/v1/projects/{0}/causalities/{1}/affected_controls";
    Urls.api_causality_attachable_controls_list = "/api/v1/projects/{0}/causalities/{1}/attachable_controls";
    Urls.api_project_control_list = "/api/v1/projects/{0}/controls";
    Urls.api_project_risk_control_detail = "/api/v1/projects/{0}/risks/{1}/controls/{2}";
    Urls.api_project_control_detail = "/api/v1/projects/{0}/controls/{1}";
    Urls.api_project_control_recurrence_detail = "/api/v1/projects/{0}/controls/{1}/recurrence";
    Urls.api_project_control_comment_list = "/api/v1/projects/{0}/controls/{1}/comments";
    Urls.api_project_control_comment_detail = "/api/v1/projects/{0}/controls/{1}/comments/{2}";
    Urls.api_project_control_tags_list = "/api/v1/projects/{0}/controls/{1}/tags";
    Urls.api_project_control_relation_list = "/api/v1/projects/{0}/controls/{1}/relations";
    Urls.api_project_control_relation_detail = "/api/v1/projects/{0}/controls/{1}/relations/{2}";
    Urls.api_project_control_references_list = "/api/v1/projects/{0}/controls/{1}/references";
    Urls.api_project_control_references_detail = "/api/v1/projects/{0}/controls/{1}/references/{2}";
    Urls.api_project_control_entries_list = "/api/v1/projects/{0}/controls/{1}/entries";
    Urls.api_project_control_cost_list = "/api/v1/projects/{0}/controls/{1}/controlcosts";
    Urls.api_project_control_cost_detail = "/api/v1/projects/{0}/controls/{1}/controlcosts/{2}";
    Urls.api_project_action_list = "/api/v1/projects/{0}/actions";
    Urls.api_project_quick_user = "/api/v1/projects/{0}/quick_user";
    Urls.api_project_cacategory_list = "/api/v1/projects/{0}/cacategories";
    Urls.api_project_cacategory_detail = "/api/v1/projects/{0}/cacategories/{1}";
    Urls.api_project_category_list = "/api/v1/projects/{0}/categories";
    Urls.api_project_category_detail = "/api/v1/projects/{0}/categories/{1}";
    Urls.api_project_tag_list = "/api/v1/projects/{0}/tags";
    Urls.api_project_tag_detail = "/api/v1/projects/{0}/tags/{1}";
    Urls.api_project_catag_list = "/api/v1/projects/{0}/catags";
    Urls.api_project_catag_detail = "/api/v1/projects/{0}/catags/{1}";
    Urls.causality_dialog_state = "/states/{0}/causality_dialog/{1}/";
    Urls.causality_dialog_state_no_causalities = "/states/{0}/causality_dialog/";
    Urls.control_dialog_state = "/states/{0}/control_dialog/{1}/";
    Urls.control_dialog_state_no_control = "/states/{0}/control_dialog/";
    Urls.control_causality_relations = "/{0}/controls/{1}/causality_relations/";
    Urls.api_project_roles_list = "/api/v1/projects/{0}/roles";
    Urls.contract_governance_state = "/contracts/{0}/governance/state";
    Urls.risk_bulk_edit_state = "/{0}/risks/bulk_menu_state/";
    Urls.control_bulk_edit_state = "/{0}/controls/bulk_menu_state/";
    Urls.action_bulk_edit_state = "/{0}/actions/bulk_menu_state/";
    Urls.risk_page_state = "/states/{0}/risk_page/{1}/";
    Urls.user_profile = "/profile/{0}/";
    Urls.change_password_suffix = "change-password/";
    Urls.update_picture_suffix = "update-picture/";
    Urls.observations_list_data = "/{0}/observation-data/";
    Urls.risk_bim_markers = "/{0}/risks/{1}/risk_bim_markers/";
    Urls.control_bim_markers = "/{0}/controls/{1}/risk_bim_markers/";
    Urls.all_risk_bim_markers = "/{0}/risks/risk_bim_markers/";
    Urls.all_control_bim_markers = "/{0}/controls/risk_bim_markers/";
    Urls.all_riskcontrol_bim_markers = "/{0}/riskcontrol/risk_bim_markers/";
    Urls.geo_json_export = "/bim/{0}/bim2d/geojson";
    Urls.saved_views = "/{0}/risks/saved_views/";
    Urls.saved_view_detail = "/{0}/risks/saved_views/{1}/";
    return Urls;
}());
exports.Urls = Urls;
function format(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return target.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
}
function resolve(name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return format.apply(void 0, __spreadArray([name], __read(args), false));
}
exports.resolve = resolve;
function trailing_slash(url) {
    return url.replace(/\/?$/, "/");
}
exports.trailing_slash = trailing_slash;
